import type { GcpOrganization } from '@repo/api-gw-sdk';
import { useDAL } from '@/contexts/useDAL';
export const useRestoreOrgsAndFolders = (): {
  orgsAndFolders: GcpOrganization[];
  isLoading: boolean;
  mutate: () => Promise<void>;
} => {
  const dal = useDAL();
  const {
    data: orgsData,
    isLoading: orgsLoading,
    mutate: mutateOrgs
  } = dal.cloudAccounts.gcpRestoreOrganization.useList();
  const {
    data: foldersData,
    isLoading: foldersLoading,
    mutate: mutateFolders
  } = dal.cloudAccounts.gcpRestoreFolder.useList();
  const orgsAndFolders = [...(orgsData?.organizations || []), ...(foldersData?.folders || [])];
  const isLoading = orgsLoading || foldersLoading;
  const mutate = async () => {
    await Promise.all([mutateOrgs(), mutateFolders()]);
  };
  return {
    orgsAndFolders,
    isLoading,
    mutate
  };
};